import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Zap } from "lucide-react";

// Sistem Kullanım Maliyeti — Sistem Yönetimi sekmesi içinde kompakt kart olarak gösterilir.
export default function CostWidget() {
  const { can } = useAuth();
  const [data, setData] = useState(null);

  const load = () => {
    const since = localStorage.getItem("groot_session_start") || "";
    api.get(`/usage/summary?since=${encodeURIComponent(since)}`).then((r) => setData(r.data)).catch(() => {});
  };

  useEffect(() => {
    if (!can("cost.read")) return;
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, []);

  if (!can("cost.read")) return <p className="text-sm text-slate-400" data-testid="cost-noperm">Bu bilgiyi görüntüleme yetkiniz yok.</p>;
  if (!data) return <p className="text-sm text-slate-400">Yükleniyor…</p>;
  const s = data.self;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="cost-panel">
      <h2 className="mb-1 flex items-center gap-2 font-heading text-lg font-bold text-slate-800">
        <Zap className="h-5 w-5 text-amber-500" /> Sistem Kullanım Maliyeti
      </h2>
      <p className="mb-4 text-sm text-slate-500">Yapay zekâ ve sistem kullanımının kredi/USD karşılığı — otomatik güncellenir. (1 USD = 5 kredi)</p>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-xl bg-slate-50 p-4 text-center">
          <p className="overline">Bu Oturum</p>
          <p className="tabular text-2xl font-bold text-slate-900" data-testid="cost-session-credits">{s.session_credits} <span className="text-sm font-normal">kredi</span></p>
          <p className="text-xs text-slate-500">~${s.session_usd}</p>
        </div>
        <div className="rounded-xl bg-slate-50 p-4 text-center">
          <p className="overline">Toplam (Siz)</p>
          <p className="tabular text-2xl font-bold text-slate-900">{s.credits} <span className="text-sm font-normal">kredi</span></p>
          <p className="text-xs text-slate-500">~${s.usd}</p>
        </div>
        {data.can_view_all && (
          <div className="rounded-xl bg-emerald-50 p-4 text-center ring-1 ring-inset ring-emerald-200">
            <p className="overline text-emerald-700">Genel Toplam</p>
            <p className="tabular text-2xl font-bold text-emerald-800" data-testid="cost-grand-total">{data.grand_total.credits} <span className="text-sm font-normal">kredi</span></p>
            <p className="text-xs text-emerald-600">~${data.grand_total.usd}</p>
          </div>
        )}
      </div>

      {data.can_view_all && (
        <div className="mt-5">
          <p className="overline mb-2">Tüm Kullanıcılar</p>
          <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
            {data.all_users.map((u, i) => (
              <div key={i} data-testid={`cost-user-${i}`} className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2 text-sm">
                <div className="min-w-0"><p className="truncate font-medium text-slate-700">{u.name}</p><p className="text-[10px] text-slate-400">{u.role_label}</p></div>
                <div className="text-right"><p className="tabular font-semibold text-slate-800">{u.credits} kr</p><p className="text-[10px] text-emerald-600">~${u.usd}</p></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
